import { useQuery } from '@tanstack/react-query';

import { getAuditLog, getEntityHistory } from './audit-log.api';
import type { AuditLogParams } from '../types/audit-log.types';

export const auditLogKeys = {
  all: ['audit-log'] as const,
  lists: () => [...auditLogKeys.all, 'list'] as const,
  list: (params: AuditLogParams) => [...auditLogKeys.lists(), params] as const,
  history: (entityType: string, entityId: string, page: number) =>
    [...auditLogKeys.all, 'history', entityType, entityId, page] as const,
};

export function useEntityHistory(
  entityType: string,
  entityId: string,
  page: number,
  options: { enabled: boolean },
) {
  return useQuery({
    queryKey: auditLogKeys.history(entityType, entityId, page),
    queryFn: ({ signal }) => getEntityHistory(entityType, entityId, page, 20, signal),
    placeholderData: (previous) => previous,
    enabled: options.enabled,
  });
}

export function useAuditLog(params: AuditLogParams, options?: { enabled?: boolean }) {
  return useQuery({
    queryKey: auditLogKeys.list(params),
    queryFn: ({ signal }) => getAuditLog(params, signal),
    placeholderData: (previous) => previous,
    enabled: options?.enabled ?? true,
  });
}
